//js/app.js
import '../../src/scss/app.scss';
//Require scripts
require('./lib/owl.carousel');
require('./script');
require('./cmp');
